PLAN_SKU_BULK_GIFT_THREE_MONTH